import Entity from './entity';
export default class User extends Entity<number> {
  userName:string
  name: string;
  surname: string;
  emailAddress: string;
  password:string;
}